import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';

import { RootStateBase } from '../../../store/baseStore';

import * as S from './styles'

import { Button } from '../../../components/Button';
import { Icon } from '@iconify/react';
import { RemovePartial } from '../../../store/base/action/baseAction';
import { StateType } from 'domain/types/base/base';
import { Modal, ModalContent } from '../../../components/Modal';

const connector = connectUtil(
    (state: RootStateBase) => ({
        partial: state.BaseReducer.Partial,
    }),
    { RemovePartial }
);

export interface PartialProps extends PropsFromRedux<typeof connector> {
}

function MasterPartial(props: PartialProps) {
    const partial = props.partial.filter((e) => e.CallBack);
    const partialLastIndex = partial.length - 1;
    const callBackText = typeof partial[partialLastIndex]?.CallBack !== 'function' ? partial[partialLastIndex]?.CallBack?.CallBackText : "Ok!";


    function handleClick() {
        partial.forEach(function handlePartialCallback(s) {
            if (typeof s?.CallBack === 'function') {
                s.CallBack();
            } else {
                s?.CallBack.CallBack();
            }
        })
        props.RemovePartial()
    }

    return (
        <Modal open={props.partial.find((e) => e.Type == StateType.Master) ? true : false}>
            <ModalContent
                overlayStyle={{
                    opacity: 0.9,
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    backdropFilter: 'blur(8px)'
                }}
                contentStyle={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px',
                    backgroundColor: 'transparent',
                    boxShadow: 'none'
                }}
            >
                <S.Container $variant="partial">
                    <S.IconContainer $variant="partial">
                        <Icon
                            icon="mdi:alert-circle"
                            style={{
                                fontSize: '72px',
                                color: '#3b82f6',
                                position: 'relative',
                                zIndex: 1,
                                filter: 'drop-shadow(0 4px 12px rgba(59, 130, 246, 0.3))'
                            }}
                        />
                    </S.IconContainer>
                    <S.Title $variant="partial">
                        Sucesso Parcial
                    </S.Title>
                    <S.MessageContainer>
                        {props.partial.map(function renderPartialMessage(m, index) {
                            return <S.Message key={index}>{m.Message}</S.Message>
                        })}
                    </S.MessageContainer>
                    <S.ButtonContainer>
                        <Button
                            onClick={handleClick}
                            iconPosition='left'
                            size='lg'
                            full={true}
                            style={{
                                borderRadius: '12px',
                                height: '52px',
                                fontSize: '16px',
                                fontWeight: '600',
                                backgroundColor: '#3b82f6',
                                borderColor: '#3b82f6',
                                transition: 'all 200ms ease-in-out',
                                boxShadow: '0 8px 24px rgba(59, 130, 246, 0.25)',
                                gap: '8px'
                            }}
                        >
                            <Icon icon="mdi:check" height="20px" color={"white"} />
                            {callBackText}
                        </Button>
                    </S.ButtonContainer>
                </S.Container>
            </ModalContent>
        </Modal>
    )
}

export default connector(MasterPartial);
